<template>
    <div>
      <!--弹出框-->
      <el-form label-width="100px" class="demo-ruleForm" style="height: 100%">
        <el-dialog title="淤地坝销号凭证上传" :visible.sync="filterDialogVisiblexhpz" :modal="false" v-dialogDrag :before-close="handleClose"
          :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
          <el-row class="rowTop" style="margin-top: 15px;">
            <el-col :span="24">
              <div class="titna">
                <span class="addSpan">销号凭证附件</span>
              </div>
              <div class='fujian'>
                <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
                  :file-list="fileList" :auto-upload='false'>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">可将多文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
                <div class='fujian' v-if="filetabledata.length!=0" style="width: 100%;display: flexbox;">
                  <ul>
                    <li v-for="(item,i) in filetabledata" :key="i" style="line-height: 28px">
                      <div style="text-align: left;display: flex;flex-direction: row;justify-content: space-between;margin-right: 6px;">
                      <div style="text-align: left;width: 400px;">{{item.ydbPdfName}}</div>
                      <div>
                        <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                        <el-button type="success" icon="el-icon-delete" circle @click="deletesfilesss(i,item)" class="btnmargin"></el-button>
                      </div>
                    </div>
                    </li>
  
  
                  </ul>
                </div>
              </div>
            </el-col>
          </el-row>
      
          <span slot="footer" class="dialog-footer">
            <el-form-item>
              <el-button round @click="empty()" type="warning">取消</el-button>
      
              <el-button round type="primary" @click="deteRmine('ruleForm')">保 存</el-button>
            </el-form-item>
          </span>
        </el-dialog>
      </el-form>
    </div>
  </template>
  
  <script>
    import {
      ydbjbxxQuery,
      yaSave,
      yaUpdate,
      dictioninfo,
      deleteFile
    } from "@/api/api";
    import addressTree from '@/components/mangement/popupaddressTree.vue';
    import axios from 'axios';
    let date = new Date();
    const currentFdate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    export default {
      props: {
        mystate: Array
      },
      data() {
        return {
          states: "",
          filterDialogVisiblexhpz: true,
          urlsss: '/userApi/minio/updateFileMulti',
          fileList: [], // 附件
          filetabledata: [], // 回显附件
          pdffiledata: [], // pdf回显
          fileUrl: '',
          downloadUrl: '/userApi/minio/downloadFile'
        };
      },
      created() {
        //初始化数据
      },
      components: {
        addressTree
      },
      methods: {
  
      
        treeClose() {
          //this.ruleForm.ydbCode = '';
          // let params = {};
          // this.list(params);
        },
        objdata(data) {
          let params = {
            ydbCode: data.ydbCode
          };
          this.list(params);
        },
        deletesfile(index, row, type) { // 删除文件
          let params = {fileName:row.ydbPdfSourceName};
          deleteFile(params).then((res) => {
              if(res.code == 200) {
                  this.$notify({
                      title: '',
                      message: res.message,
                      type: 'success'
                  });
              if(type === 'xfq') this.ImgfileListData1.splice(index, 1);
              if(type === 'xfh') this.ImgfileListData2.splice(index, 1);
              if (type === 'fujian') {
                this.filetabledata.splice(index, 1);
              }
              }
          })
        },
        // deletesfilesss(index, row) { // 删除文件
        //   let params = {fileName:row.ydbPdfSourceName};
        //   deleteFile(params).then((res) => {
        //   	if(res.code == 200) {
        //   		this.$notify({
        //   			title: '',
        //   			message: res.message,
        //   			type: 'success'
        //   		});
        //       this.filetabledata.splice(index, 1);
        //   	}
        //   })
        // },
        deletesfilesss(index, item) {
    // 显示确认删除的弹窗
    this.$confirm('确认删除此文件吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      // 构建请求URL，包含Access-Token
      const url = `/userApi/minio/removeObject/${item.ydbPdfSourceName}`;
      // 构建请求头，包含Content-Type和Access-Token
      const headers = {
        "Content-Type": "application/json",
        "Access-Token": this.$store.state.token
      };
      // 使用axios的get方法发送请求
      axios.get(url, { headers }).then(res => {
        if (res.data.code === 200) {
          // 删除操作成功的逻辑
          console.log('File deleted successfully');
          this.filetabledata.splice(index, 1);
        } else {
          // 删除操作失败的逻辑
          console.error('Error deleting file:', res.data.message);
          this.$notify({
            title: 'Error',
            message: res.data.message,
            type: 'error'
          });
        }
      }).catch(err => {
        // 处理请求错误
        console.error('Error deleting file:', err);
        this.$notify({
          title: 'Error',
          message: 'Failed to delete file',
          type: 'error'
        });
      });
  
      // 构建请求URL，包含Access-Token
      const url2 = `/userApi/ydb/basic/clearPdfInfo`;
      // 使用axios的get方法发送请求
      axios.get(url2, { headers, params: { ydbCode: item.ydbCode } }).then(res => {
        if (res.data.code === 200) {
          // 删除操作成功的逻辑
          console.log('File deleted successfully');
        } else {
          // 删除操作失败的逻辑
          console.error('Error deleting file:', res.data.message);
          this.$notify({
            title: 'Error',
            message: res.data.message,
            type: 'error'
          });
        }
      }).catch(err => {
        // 处理请求错误
        console.error('Error deleting file:', err);
        this.$notify({
          title: 'Error',
          message: 'Failed to delete file',
          type: 'error'
        });
      });
    }).catch(() => {
      // 用户取消删除操作
      console.log('删除操作已取消');
    });
  },
  
        handleRemove(file, fileList) { // 删除文件
          for (let i = 0; i < this.fileList.length; i++) {
            if (file.name == this.fileList[i].name) {
              this.fileList.splice(this.fileList[i], 1)
            }
          }
        },
        changes(file, fileList) {
    let num = 1024.00;
    
    // 检查文件大小
    if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 50) {
      fileList.splice(fileList.length - 1, 1);
      this.$message.error('选择文件大于50M，请重新选择！');
    }
    // 检查文件类型是否为PDF
    else if (!file.name.toLowerCase().endsWith('.pdf')) {
      fileList.splice(fileList.length - 1, 1);
      this.$message.error('选择的文件不是PDF格式，请重新选择！');
    }
    else {
      this.fileList.push(file.raw);
    }
  },
  
  
  deteRmine(formName) {
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Token": this.$store.state.token // 请替换为实际的Access-Token值
      },
    };
    console.log("this.fileList",this.fileList);
    // this.$emit("conditionSearch", null);
    //       this.$emit("getpdfcancel");
    if (this.fileList.length !== 0 && this.fileList.length == 1) {
      this.fileList.forEach((file, index) => {
        let formData = new FormData();
        formData.append('file', file);
  
        axios.post(this.urlsss, formData, config).then(res => {
          if (res.data.code === 200) {
            let uploadedFile = {
              sourceName: res.data.data[0].sourceName,
              urlHttp: res.data.data[0].urlHttp,
              fileName: res.data.data[0].fileName,
              fileType: res.data.data[0].fileType
            };

            // 使用字符串模板拼接字符串
   // let concatenatedString = `${uploadedFile.sourceName}${uploadedFile.fileType}${uploadedFile.fileName}`;

    // let concatenatedString = {"fileName":uploadedFile.fileName,
    // "filePath":uploadedFile.sourceName,
    // "filerype":uploadedFile.fileType}
    // 将对象转换为 JSON 字符串
    let concatenatedString = JSON.stringify({
      "fileName": uploadedFile.fileName,
      "filePath": uploadedFile.sourceName,
      "fileType": uploadedFile.fileType
    });

  
          
                this.$emit("conditionSearch", null);
                this.$emit("uploadxhpzToDele",concatenatedString)
                this.$emit("getxhpzpdfcancel");
              } 
            //   else {
            //     // 查询失败
            //     this.$notify({
            //       title: "提示",
            //       message: codeExistsRes.data.message,
            //       type: "error"
            //     });
            //   }
            //   }).catch(codeExistsErr => {
            //   // 处理查询请求的错误
            //   console.error(codeExistsErr);
            //   this.$notify({
            //     title: "提示",
            //     message: "查询淤地坝代码请求失败",
            //     type: "error"
            //   });
            // });
  
         // } 
          else {
            // 上传失败的逻辑
            this.$notify({
              title: "提示",
              message: res.data.message,
              type: "error"
            });
          }
        }).catch(err => {
          // 处理上传请求的错误
          console.error(err);
          this.$notify({
            title: "提示",
            message: "文件上传失败",
            type: "error"
          });
        });
      });
    }else{
        this.$notify({
              title: "提示",
              message: "上传失败！只需上传一个销号凭证",
              type: "error"
            });
      this.$emit("conditionSearch", null);
      this.$emit("getxhpzpdfcancel");
    }
    
  },
  
  
        empty() {
          this.$emit("getxhpzpdfcancel");
  
        },
        optionsChange() {
  
        },
        handleNodeClick(data, e) {
  
          this.sjcdid = data.id;
          //this.ruleForm.sjcd = data.menuName;
  
        },
  
        handleClose() {
         this.$emit("getxhpzpdfcancel");
        },
        // DownloadFile(index, row) {
        //   // 下载文件
        //   window.open(this.downloadUrl + row.ydbPdfSourceName);
        // },
  
        DownloadFile(index, item) {
          // 构建请求URL，包含Access-Token
          const url = `/userApi/minio/downloadFile/${item.ydbPdfSourceName}`;
          // 构建请求头，包含Content-Type和Access-Token
          // const headers = {
          //   "Access-Token": this.$store.state.token
          // };
          // 设置请求头
          const headers = new Headers();
          headers.append('Access-Token', this.$store.state.token); // 设置授权头，替换YourAccessToken为实际的访问令牌
        
          // 发起 Fetch 请求
          fetch(url, {
            method: 'GET',
            headers: headers,
          })
            .then(response => response.blob())
            .then(blob => {
              // 创建一个虚拟的链接元素，模拟点击下载
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = item.ydbPdfName; // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
              document.body.appendChild(link);
        
              // 模拟点击
              link.click();
        
              // 移除虚拟链接元素
              document.body.removeChild(link);
            })
            .catch(error => console.error('下载失败：', error));
        },
        deletesfile(index, row, type) {
          // 删除文件
          let params = {
            fileName: row.fileName
          };
          deleteFile(params).then((res) => {
            if (res.code == 200) {
              this.$notify({
                title: '',
                message: res.message,
                type: 'success'
              });
              if (type === 'xfq') this.ImgfileListData1.splice(index, 1)
              if (type === 'xfh') this.ImgfileListData2.splice(index, 1)
            }
          })
        },
  
        imgzoom(url) {
          window.open(url);
        },
  
        imghandl1(file) {
          this.dialogImageUrl = file.url;
          this.imgdialogVisible = true;
        },
  
        imghandleRemove1(file, fileList) {
          // 删除文件
          for (let i = 0; i < this.fileList1.length; i++) {
            if (file.name == this.fileList1[i].name) {
              this.fileList1.splice(this.fileList1[i], 1);
            }
          }
        },
  
        imgchanges1(file, fileList) {
          let num = 1024.0
          if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
            fileList.splice(fileList.length - 1, 1)
            this.$message.error('选择文件大于10M，请重新选择！')
          } else {
            this.fileList1.push(file.raw)
          }
        },
  
        imghandl2(file) {
          this.dialogImageUrl = file.url;
          this.imgdialogVisible = true;
        },
  
        imghandleRemove2(file, fileList) {
          // 删除文件
          for (let i = 0; i < this.fileList2.length; i++) {
            if (file.name == this.fileList2[i].name) {
              this.fileList2.splice(this.fileList2[i], 1);
            }
          }
        },
  
        imgchanges2(file, fileList) {
          let num = 1024.0
          if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
            fileList.splice(fileList.length - 1, 1)
            this.$message.error('选择文件大于10M，请重新选择！')
          } else {
            this.fileList2.push(file.raw)
          }
        },
      },
      mounted() {
        // this.getsjfjinfo();
        // this.getyaztinfo();
  
        // this.states = this.mystate[0];
        // this.row = this.mystate[1];
  
        
      }
    };
  </script>
  
  <style scoped="scoped">
    >>>.el-dialog {
      width: 1000px;
    }
  
    >>>.el-dialog__body {
      height: 450px;
      overflow: auto;
    }
  
    .treebox {
      width: 100%;
      margin: 0;
    }
  
    .trees {
      width: 98%;
      float: left;
      max-height: 300px;
      height: 60px;
      line-height: 30px;
      padding-left: 2%;
      margin-top: 5px;
    }
  
    .fujian {
      width: calc(100% - 112px);
      width: -webkit-calc(100% - 112px);
      width: -moz-calc(100% - 112px);
      float: right;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
      overflow: auto;
    }
  
    .tp {
      width: calc(100% - 132px);
      float: right;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
    }
  
    .addSpan {
      line-height: 30px;
      margin-right: 10px;
    }
  </style>
  